<template>
  <RadioGroup v-model="selectedOrgId" class="space-y-2">
    <RadioGroupLabel class="sr-only"> Organization </RadioGroupLabel>

    <template
      v-for="(orgOption, orgOptionKey) in orgOptions"
      :key="'orgOption-' + orgOptionKey"
    >
      <RadioGroupOption
        v-slot="{checked, active}"
        :value="orgOption.value"
        class="ring-0 group"
      >
        <div
          class="rounded-lg rounded flex items-center cursor-pointer border dark:border-gray-700"
          :class="[
            checked
              ? 'outline outline-1 outline-blue-600 border-blue-600'
              : 'border-gray-300 hover:border-gray-400',
            active
              ? 'group-focus-visible:ring group-focus-visible:ring-3 group-focus-visible:ring-offset-1 group-focus-visible:ring-blue-600/30'
              : '',
          ]"
        >
          <RadioGroupLabel as="div">
            <cart-block
              :org-id="orgOption.value ? orgOption.value : null"
              :show-details="showDetails"
            />
          </RadioGroupLabel>
        </div>
      </RadioGroupOption>
    </template>
  </RadioGroup>
</template>

<script>
  import {RadioGroup, RadioGroupLabel, RadioGroupOption} from '@headlessui/vue';
  import {mapState} from 'vuex';
  import CartBlock from '@console/components/cart/CartBlock.vue';
  export default {
    components: {CartBlock, RadioGroupOption, RadioGroupLabel, RadioGroup},
    props: {
      modelValue: {
        type: [String, Number],
        default: '',
      },
      orgOptions: {
        type: Array,
        default: () => [],
      },
      showDetails: {
        type: Boolean,
        default: true,
      },
    },
    emits: ['update:modelValue'],

    computed: {
      ...mapState({
        user: (state) => state.account.user,
        orgs: (state) => state.orgs.orgs,
      }),

      selectedOrgId: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        },
      },

      selectedOrg() {
        return this.orgs.find((org) => org.id === parseInt(this.selectedOrgId));
      },
    },
  };
</script>
